import { PropsWithChildren } from 'react';
import { Tab } from '@headlessui/react';

export const TabList = ({ children }: PropsWithChildren) => (
  <div className='relative w-full overflow-hidden'>
    <Tab.List className="my-2 flex w-full gap-5 overflow-x-auto border-b-2 border-neutral-200 outline-none after:block after:min-w-[1rem] after:shrink-0 after:content-[''] sm:gap-7 [&::-webkit-scrollbar]:hidden">
      {children}
    </Tab.List>
    <div className='pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-[#FCFCFC] to-transparent sm:hidden' />
  </div>
);
